<template>
  <div>
    <div v-if="(isInitialStatusIsAvaliable || isReservado) && !willCheckIn && !willChangeStatus && !willWalkIn && !willCheckInReserved">
      <v-card-text>
        <div class="d-flex flex-column">
          <span class="mx-auto mb-2">
            Esse quarto já se encontra com status <span class="font-weight-black">{{ isReservado ? 'reservado' : 'disponível' }}</span>.
          </span>
          <span class="mx-auto mb-2">
            O que deseja fazer?
          </span>
          <div class="d-flex mx-auto mb-2 flex-column">
            <v-btn
              v-if="isInitialStatusIsAvaliable"
              class="ma-2"
              x-large
              :loading="loading"
              color="primary"
              @click="onClickToWillCheckIn()"
            >
              Realizar
              Checkin
            </v-btn>
            <v-btn
              v-if="isInitialStatusIsAvaliable"
              class="ma-2"
              x-large
              :loading="loading"
              color="primary"
              @click="onClickToWillWalkIn()"
            >
              Realizar
              Walk-in
            </v-btn>
            <v-btn
              v-if="isReservado"
              class="ma-2"
              x-large
              :loading="loading"
              color="primary"
              @click="onClickToWillCheckInReserved()"
            >
              Realizar
              Check-in
            </v-btn>
            <div class="flex-grow-1 d-flex">
              <v-divider class="my-auto"></v-divider>
              <span class="my-auto mx-2">Ou</span>
              <v-divider class="my-auto"></v-divider>
            </div>
            <v-btn
              class="ma-2"
              x-large
              :loading="loading"
              color="primary"
              @click="onClickToWillChangeStatus()"
            >
              Mudar
              Status
            </v-btn>
            <v-btn
              v-if="room.today_reserve && !isReservado"
              class="ma-2"
              x-large
              :loading="loading"
              color="success"
              @click="onClickToWillReserve()"
            >
              Reservar
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </div>
    <div v-if="willChangeStatus">
      <v-card-actions>
        <v-row>
          <v-col
            v-if="room.today_reserve && !isReservado"
            class="text-left"
          >
            <v-btn
              x-large
              color="success"
              @click="onClickToWillReserve()"
            >
              Reservar
            </v-btn>
          </v-col>
          <v-col class="text-right">
            <v-btn
              x-large
              :loading="loading"
              color="primary"
              @click="save()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              v-model="status"
              large
              outlined
              label="Status"
              :items="items"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="status == 'manutencao' || status == 'stand-by'">
          <v-col cols="6">
            <v-text-field
              v-model="start_at"
              :min="date_now"
              :max="expected_end_at"
              hide-details
              outlined
              type="date"
              label="Data de Inicio"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="expected_end_at"
              :min="start_at"
              hide-details
              outlined
              type="date"
              label="Previsão para término"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-textarea
              v-model="description"
              rows="6"
              outlined
              label="Descrição"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <dialog-available
      v-if="willCheckIn"
      :room="room"
      @close="onClose()"
      @updategrid="updateGrid()"
    />
    <dialog-walkin
      v-if="willWalkIn"
      :room="room"
      @close="onClose()"
      @updategrid="updateGrid()"
    />
    <dialog-available
      v-if="willCheckInReserved"
      :room="room"
      @close="onClose()"
      @updategrid="updateGrid()"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import DialogAvailable from './DialogAvailable.vue'
import DialogWalkin from './DialogWalkin.vue'

export default {
  components: {
    DialogAvailable,
    DialogWalkin,
  },
  props: {
    room: {},
  },
  data: () => ({
    loading: false,
    isInitialStatusIsAvaliable: false,
    isReservado: false,
    willChangeStatus: false,
    willCheckIn: false,
    willWalkIn: false,
    willCheckInReserved: false,
    status: null,
    description: '',
    start_at: null,
    expected_end_at: null,
    items: [
      { value: 'disponivel', text: 'Disponível' },
      { value: 'manutencao', text: 'Manutenção' },
      { value: 'stand-by', text: 'Stand-by' },
      { value: 'limpeza', text: 'Limpeza' },
      { value: 'conferencia', text: 'Conferência' },
      { value: 'sujo', text: 'Sujo' },
    ],
  }),
  computed: {
    date_now() {
      return new Date(Date.now())
    },
  },
  watch: {
    room() {
      this.initializeForm()
    },
  },
  created() {
    this.initializeForm()
  },
  methods: {
    ...mapActions('manager_room', ['updateStatusRoom']),
    initializeForm() {
      this.status = this.room.status
      this.description = ''
      if (this.room.lastMaintenance) {
        this.description = this.room.lastMaintenance.description
        this.expected_end_at = this.room.lastMaintenance.expected_end_at
        this.start_at = this.room.lastMaintenance.start_at
      } else if (this.room.lastInfoStatus) {
        this.description = this.room.lastInfoStatus.description
        this.expected_end_at = this.room.lastInfoStatus.expected_end_at
        this.start_at = this.room.lastInfoStatus.start_at
      }
      this.isInitialStatusIsAvaliable = this.status == 'disponivel'
      this.isReservado = this.status == 'reservado'
      this.willChangeStatus = !(this.isInitialStatusIsAvaliable || this.isReservado)
      this.willCheckIn = false
      this.willWalkIn = false
      this.willCheckInReserved = false
    },
    save() {
      this.loading = true

      const data = {
        status: this.status,
        room_id: this.room.id,
        description: this.description,
        start_at: this.start_at,
        expected_end_at: this.expected_end_at,
      }
      this.updateStatusRoom(data)
        .then(response => {
          if (response) this.$toast.success('Salvo com sucesso')
          this.$emit('close')
          this.$emit('updategrid')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClickToWillChangeStatus() {
      this.willChangeStatus = true
      this.willCheckIn = false
      this.willWalkIn = false
      this.willCheckInReserved = false
    },
    onClickToWillCheckIn() {
      this.willCheckIn = true
      this.willChangeStatus = false
      this.willWalkIn = false
      this.willCheckInReserved = false
    },
    onClickToWillWalkIn() {
      this.willWalkIn = true
      this.willChangeStatus = false
      this.willCheckIn = false
      this.willCheckInReserved = false
    },
    onClickToWillCheckInReserved() {
      this.willCheckInReserved = true
      this.willChangeStatus = false
      this.willCheckIn = false
      this.willWalkIn = false
    },
    onClickToWillReserve() {
      this.loading = true
      const data = {
        status: 'reservado',
        room_id: this.room.id,
        description: '',
        start_at: null,
        expected_end_at: null,
      }
      this.updateStatusRoom(data)
        .then(response => {
          if (response) this.$toast.success('Quarto marcado como reservado')
          this.$emit('close')
          this.$emit('updategrid')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClose() {
      this.$emit('close')
    },
    updateGrid() {
      this.$emit('updategrid')
    },
  },
}
</script>
